import React from 'react';

import {
  TemplateSection,
  TemplateSkillItem,
} from '@xing-com/crate-lebenslauf-components';
import { useReadVitaReactiveVariable } from '@xing-com/crate-lebenslauf-hooks';

export const useSkills = (): JSX.Element[] => {
  const [data, setData] = React.useState<JSX.Element[]>([]);
  const { cv } = useReadVitaReactiveVariable();

  React.useEffect(() => {
    const skills = cv?.skills;
    const items =
      skills?.map((skill) => (
        <TemplateSkillItem key={skill?.skill} {...skill} />
      )) || [];

    setData(
      items.length
        ? [
            <div key="skill-0">
              <TemplateSection name="skills" />
              {items[0]}
            </div>,
            ...items.slice(1),
          ]
        : []
    );
  }, [cv]);

  return data;
};
